import { Component } from '@angular/core';

@Component({
  selector: 'app-user-no-selected',
  templateUrl: './user-no-selected.component.html',
  styleUrls: ['./user-no-selected.component.css'],
})
export class UserNoSelectedComponent {}
